import "./styles.css";
import { ReactComponent as CheckSquare } from "../../assets/check-square.svg";
import { ReactComponent as CheckSquareFill } from "../../assets/check-square-fill.svg";

function ConfirmButton(props) {
  const { label, isChecked, onClick } = props;

  return (
    <button
      className={`confirm-button ${isChecked ? " checked" : ""}`}
      onClick={onClick}
    >
      <div>
        {!isChecked && <CheckSquare />}
        {isChecked && <CheckSquareFill />}
      </div>
      <div>{label}</div>
    </button>
  );
}

export default ConfirmButton;
